import { all, call, fork, put, select, take } from "redux-saga/effects";
import { Company } from "../../domain/model/company";
import { Customer } from "../../domain/model/customer";
import { JobCareer } from "../../domain/model/job_career";
import { PastCaseProject } from "../../domain/model/past_case_project";
import { User } from "../../domain/model/user";
import { ICompanyRepository } from "../../domain/repository/company_repository";
import { ICustomerRepository } from "../../domain/repository/customer_repository";
import { IJobCareerRepository } from "../../domain/repository/job_career_repository";
import { IPastCaseProjectRepository } from "../../domain/repository/past_case_project_repository";
import { createApiClient, IApiClient } from "../../infra/api/client";
import { createCompanyAPI } from "../../infra/api/service/company_api";
import { createCustomerAPI } from "../../infra/api/service/customer_api";
import { createJobCareerAPI } from "../../infra/api/service/job_career_api";
import { createPastCaseProjectAPI } from "../../infra/api/service/past_case_project_api";
import {
  ClientCustomerActionType,
  createClientCustomerActionCreator,
  IClientCustomerActionCreator,
  IRequestGetCustomerAction,
} from "../action/client_customer_action";
import { GetCustomerResponse } from "../response/customer_response";
import { AppState } from "../store/app_state";
import { AuthState } from "../store/auth_state";
import { handleErrorForHandler } from "./handleErrorForHandler";

const apiClient: IApiClient = createApiClient();
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const jobCareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const companyRepository: ICompanyRepository = createCompanyAPI(apiClient);
const actionCreator: IClientCustomerActionCreator =
  createClientCustomerActionCreator();
const pastCaseProjectRepository: IPastCaseProjectRepository =
  createPastCaseProjectAPI(apiClient);

function* handleGetCustomerInClientCustomer() {
  while (true) {
    try {
      const action: IRequestGetCustomerAction = yield take(
        ClientCustomerActionType.REQUEST_GET_CUSTOMER
      );
      let customer: Customer;
      let jobCareers: JobCareer[];
      let company: Company;
      const authSelector = (state: AppState) => state.authReducer;
      const _authState: AuthState = yield select(authSelector);
      const user: User | null = _authState.user;
      const companyID = user ? (user.client ? user.client.companyID : "") : "";
      [customer, jobCareers, company] = yield all([
        call(getCustomer, action.item.customerId),
        call(getAllByClientJobCareer, action.item.customerId),
        call(getCompany, companyID),
      ]);
      const pastCaseProjects: PastCaseProject[] = yield call(
        getAllByClientPastCaseProject,
        action.item.customerId
      );
      const res: GetCustomerResponse = new GetCustomerResponse();
      res.customer = customer;
      res.jobCareer = jobCareers;
      res.company = company;
      res.postCaseProjects = pastCaseProjects;
      yield put(actionCreator.callbackGetCustomerAction(true, res));
    } catch (error) {
      yield fork(handleErrorForHandler, error);
      yield put(
        actionCreator.callbackGetCustomerAction(
          false,
          undefined,
          error.toString()
        )
      );
    }
  }
}

const getCustomer = (customerId: string): Promise<Customer> => {
  return customerRepository.get(customerId);
};

const getCompany = (companyId: string): Promise<Company> => {
  return companyRepository.get(companyId);
};

const getAllByClientJobCareer = (customerId: string): Promise<JobCareer[]> => {
  return jobCareerRepository.getAllByClient(customerId);
};

const getAllByClientPastCaseProject = (
  customerId: string
): Promise<PastCaseProject[]> => {
  return pastCaseProjectRepository.getAllByClient(customerId);
};

export { handleGetCustomerInClientCustomer };



// WEBPACK FOOTER //
// ./src/presentation/handler/client_customer_handler.ts